import React from "react";

function PageNum4() {
  return (
    <div className="fourthPage">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-2 col-md-4 col-sm-6 mb-4 mt-5">
            <div className="img1">
              <img src="img/Vector (3).png" className="img-fluid" alt="" />
              <p>أسرع على الطريق، أأمن أذكى وأكفأ</p>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 mb-4 mt-5">
            <div className="img1">
              <img src="img/Vector (4).png" className="img-fluid" alt="" />
              <p>وفر ٨٠٪ من مصاريف البنزين بالشحن الكهربائي</p>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 mb-4 mt-5">
            <div className="img1">
              <img src="img/Vector (5).png" className="img-fluid" alt="" />
              <p>مصاريف صيانة أقل سنويًا أبسط، وأكفأ</p>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 mb-4 mt-5">
            <div className="img1">
              <img src="img/Vector (6).png" className="img-fluid" alt="" />
              <p>أصح لبيئة نظيفة ليك ولعالمك</p>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-6 mb-4 mt-5">
            <div className="img1">
              <img src="img/Vector (7).png" className="img-fluid" alt="" />
              <p>تقدر تشحن في المحطة، في البيت، في أي مكان</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center text-center">
          <div className="h1style">هل مناسبة لإحتياجاتي؟</div>
          <p className="ptext">
            التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض وعند
            موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من
          </p>
          <div className="fBottons2 d-flex text-center align-items-center justify-content-center gap-3 ms-2 me-2">
            <button className="btn btn-end text-black rounded-4">
              <img src="img/Vector 122.svg" alt="icon" /> إبدأ الإختبار
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNum4;
